<script>
	import { onMount } from 'svelte';
	import mainImage from './img/main.png';

	import { push } from 'svelte-spa-router';
	import { link } from 'svelte-spa-router';
	import Router from 'svelte-spa-router';
	
	import Home from './routes/Home.svelte';
	import About from './routes/About.svelte';
	import Academic from './routes/Academic.svelte';
	import Stack from './routes/Stack.svelte';
	import Portfolio from './routes/Portfolio.svelte';
	import Career from './routes/Career.svelte';
	import Contact from './routes/Contact.svelte';
	
	import NavBar from './NavBar.svelte';

	const routes = {
		'/': Home,
		'/About': About,
		'/Academic': Academic,
		'/Stack': Stack,
		'/Portfolio': Portfolio,
		'/Career': Career,
		'/Contact': Contact
	};

	let menuOpen = false;
</script>

<NavBar bind:menuOpen />

<main>
	<Router {routes} />
</main>

<style>
	:global(body) {
		margin: 0;
		padding: 0;
		font-family: 'Pretendard', sans-serif;
		background-color: var(--color-background, #ffffff);
		color: var(--color-text, #000000);
	}

	main {
		width: 100%;
		height: auto;
		margin-top: 60px; /* 헤더 높이만큼 여백 추가 */
	}

	/* 링크 스타일 - 전역으로 적용 */
	:global(a) {
		text-decoration: none;
		color: inherit;
	}
	
	/* 커스텀 스크롤바 스타일 - 모든 페이지에 적용 */
	:global(*::-webkit-scrollbar) {
		width: 12px; /* 스크롤바 너비 */
		height: 12px; /* 가로 스크롤바 높이 */
	}
	
	:global(*::-webkit-scrollbar-track) {
		background: #000000; /* 검정 바탕 */
		border-radius: 0; /* 네모난 모양 */
	}
	
	:global(*::-webkit-scrollbar-thumb) {
		background: #000000; /* 검정 바탕 */
		border-radius: 0; /* 네모난 모양 */
		border: 2px solid #ffffff; /* 하얀색 테두리 */
	}
	
	:global(*::-webkit-scrollbar-thumb:hover) {
		background: #333333; /* 호버 시 약간 밝은 배경 */
	}
	
	/* Firefox용 스크롤바 스타일 (Firefox는 다른 방식으로 스크롤바 지원) */
	:global(html) {
		scrollbar-width: thin;
		scrollbar-color: #000000 #000000;
	}
	
	/* 스크롤바 스타일이 적용되지 않는 브라우저를 위한 기본 스타일 */
	:global(body) {
		overflow-y: auto;
	}
</style>